import React from 'react';

/**
 * Reusable error state component for Security Groups pages.
 * Displays a consistent error message with retry functionality.
 * @param {Object} props - Component props
 * @param {string} props.title - The page title to display (default: "Security Groups")
 * @param {string} props.icon - The icon class to display (default: "fas fa-shield-alt")
 * @param {string} props.message - Error message (default: "There was an error loading the data.")
 * @param {string} props.description - Additional error description
 * @param {() => void} props.onRetry - Callback function for retry button
 * @param {boolean} props.showRetry - Whether to show the retry button (default: true)
 * @returns {JSX.Element} An error state with retry option
 */
const ErrorState = ({ 
  title = "Security Groups", 
  icon = "fas fa-shield-alt",
  message = "There was an error loading the data.",
  description = "Please try again or contact support if the problem persists.",
  onRetry = () => window.location.reload(),
  showRetry = true
}) => {
  return (
    <div className="page-inner">
      <header className="page-title-bar">
        <h1 className="page-title">
          <i className={`${icon} text-muted mr-2`}></i>{title}
        </h1>
      </header>
      <div className="page-section">
        <div className="alert alert-danger">
          <h4>
            <i className="fas fa-exclamation-triangle"></i> Error
          </h4>
          <p className="mb-2">{message}</p>
          {description && (
            <p className="text-muted mb-3">{description}</p>
          )}
          {showRetry && (
            <button
              className="btn btn-primary btn2 mt-2"
              onClick={onRetry}
            >
              <i className="fas fa-sync mr-2"></i>
              Retry
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorState;
